import React from 'react';
import PaymentFormClaroSocioContainer from '../containers/PaymentFormClaroSocioContainer'
import { Page } from 'react-onsenui';
import * as sdkclaro from '@claropay/claro-pay-sdk-v2'
import { GenericFormContextProvider } from '../../context/genericFormContext';

const SearsPage = ({ match, location }) => {
    const { 
        state: { 
            sdkVersion, 
            paymentsConfig, 
            isClaroPartner,
            amountPlan,
            infoPlanSears,
            noInternet,
            searsCardNumber,
            paymentCard
        }
    } = location;
    sdkclaro.getInstance().switchGoBackButton(true)
    return (
        <Page id="sears-page">
            <GenericFormContextProvider>
            <PaymentFormClaroSocioContainer 
                serviceConfigIndex={0} 
                sdkVersion = {sdkVersion}
                paymentsConfig = {paymentsConfig} 
                isClaroPartner = {isClaroPartner}
                amountPlan = {amountPlan}
                infoPlanSears = {infoPlanSears}
                noInternet ={noInternet}
                searsCardNumber = {searsCardNumber}
                paymentCard = {paymentCard}
            />
            </GenericFormContextProvider>
        </Page>    
  );
};


export default SearsPage